import { render, staticRenderFns } from "./example-section.vue?vue&type=template&id=2d398e72&scoped=true&"
import script from "./example-section.vue?vue&type=script&lang=js&"
export * from "./example-section.vue?vue&type=script&lang=js&"
import style0 from "./example-section.vue?vue&type=style&index=0&id=2d398e72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d398e72",
  null
  
)

export default component.exports